import { create } from 'zustand';
import { DISPLAY_CURRENCIES, isDisplayCurrency, type DisplayCurrency } from '@/lib/currency';

interface CurrencyState {
  currency: DisplayCurrency;
  setCurrency: (c: DisplayCurrency) => void;
}

const KEY = 'shopgnd-display-currency';

function load(): DisplayCurrency {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw && isDisplayCurrency(raw)) return raw;
  } catch {
    /* ignore */
  }
  return 'XCD';
}

export const useCurrencyStore = create<CurrencyState>((set) => ({
  currency: load(),
  setCurrency: (c) => {
    if (!DISPLAY_CURRENCIES.includes(c)) return;
    try {
      localStorage.setItem(KEY, c);
    } catch {
      /* ignore */
    }
    set({ currency: c });
  },
}));
